const SEVERITY_MAP = {
  CRITICAL: { color: '#c62828', backgroundColor: '#ffebee', label: 'Critical', priority: 1 },
  HIGH:     { color: '#e65100', backgroundColor: '#fff3e0', label: 'High',     priority: 2 },
  MEDIUM:   { color: '#f57f17', backgroundColor: '#fffde7', label: 'Medium',   priority: 3 },
  LOW:      { color: '#2e7d32', backgroundColor: '#e8f5e9', label: 'Low',      priority: 4 },
  UNKNOWN:  { color: '#757575', backgroundColor: '#f5f5f5', label: 'Unknown',  priority: 5 },
};

export function getSeverityInfo(severity) {
  return SEVERITY_MAP[(severity || '').toUpperCase()] ?? SEVERITY_MAP.UNKNOWN;
}
